export function numberToWords(amount: number): string {
  const a = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ]
  const b = [
    '',
    '',
    'Twenty',
    'Thirty',
    'Forty',
    'Fifty',
    'Sixty',
    'Seventy',
    'Eighty',
    'Ninety',
  ]

  const toWords = (num: number): string => {
    if (num === 0) return 'Zero'
    if (num < 20) return a[num]
    if (num < 100)
      return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '')
    if (num < 1000)
      return (
        a[Math.floor(num / 100)] +
        ' Hundred' +
        (num % 100 ? ' ' + toWords(num % 100) : '')
      )
    if (num < 1000000)
      return (
        toWords(Math.floor(num / 1000)) +
        ' Thousand' +
        (num % 1000 ? ' ' + toWords(num % 1000) : '')
      )
    return (
      toWords(Math.floor(num / 1000000)) +
      ' Million' +
      (num % 1000000 ? ' ' + toWords(num % 1000000) : '')
    )
  }

  const fixed = Number(amount).toFixed(2)
  const [ringgitStr, senStr] = fixed.split('.')
  const ringgit = parseInt(ringgitStr, 10)
  const sen = parseInt(senStr, 10)

  let result = ''

  if (ringgit > 0) {
    result += toWords(ringgit) + ' Ringgit'
  }

  if (sen > 0) {
    result += (ringgit > 0 ? ' and ' : '') + toWords(sen) + ' Sen'
  }

  if (!result) result = ' Zero Ringgit'

  return result + ' Only'
}
